import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';
export interface ToasterMessageParams {
  successMessage?: string;
  errorMessage?: string;
  successTick?: 'isNativeApp' | boolean;
  failureCross?: 'isNativeApp' | boolean;
  timeOut?: number;
}
@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private message = new BehaviorSubject<ToasterMessageParams>({});
  constructor(private clipboard: Clipboard) {}
  setMessage(message: ToasterMessageParams) {
    if (message?.successMessage) {
      this.notifyUser();
    } else {
      this.notifyUserError();
    }
    this.message.next(message);
  }
  returnMessage() {
    return this.message.asObservable();
  }
  copyContentToClipBoard(content: string) {
    this.clipboard.copy(content);
    this.setMessage({
      errorMessage: '',
      successMessage: 'Copied',
    });
  }

  playTone(audioCtx: AudioContext, freq: number, startTime: number) {
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.value = freq;

    // Envelope: quick attack, smooth decay
    gainNode.gain.setValueAtTime(0, startTime);
    gainNode.gain.linearRampToValueAtTime(0.4, startTime + 0.01); // attack
    gainNode.gain.exponentialRampToValueAtTime(0.001, startTime + 0.12); // decay

    oscillator.connect(gainNode).connect(audioCtx.destination);
    oscillator.start(startTime);
    oscillator.stop(startTime + 0.15);
  }

  playChord(duration: number, frequency: number, volume: number, osc: any) {
    return new Promise<void>((resolve, reject) => {
      duration = duration || 200;
      volume = volume || 100;

      try {
        const audioCtx = new window.AudioContext();
        const oscillator = audioCtx.createOscillator();
        const gainNode = audioCtx.createGain(); // Create gain node for volume control

        // oscillator.type = 'sine'; // Sine wave
        oscillator.type = osc;

        gainNode.gain.value = 0.1;

        gainNode.gain.exponentialRampToValueAtTime(
          gainNode.gain.value,
          audioCtx.currentTime + 0.03,
        );

        oscillator.frequency.setValueAtTime(frequency, audioCtx.currentTime);
        gainNode.gain.setValueAtTime(volume * 0.01, audioCtx.currentTime); // Set volume

        oscillator.connect(gainNode);
        gainNode.connect(audioCtx.destination);
        oscillator.start(audioCtx.currentTime);
        oscillator.stop(audioCtx.currentTime + duration);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  getUserData() {
    return JSON.parse(localStorage.getItem('userData') || '{}');
  }
  getNotificationVolume() {
    let volume = 30;
    const userPreferences = this.getUserData()?.preferences || {};
    // the variable used will seem strange. Initally there was only mute and unmute option. Recycling the key so that it wont be wasted.
    if ('mute_notification' in userPreferences) {
      if (userPreferences?.mute_notification === true) {
        volume = 0;
      } else if (userPreferences?.mute_notification === false) {
        volume = 30;
      } else {
        volume = userPreferences?.mute_notification;
      }
    } else {
      volume = 30;
    }
    return volume;
  }

  async notifyUser(actionResult: string = 'success') {
    let volume = this.getNotificationVolume();
    let oscType = 'sine';
    const audioCtx = new window.AudioContext();

    if (volume) {
      if (actionResult === 'success') {
        const now = audioCtx.currentTime;
        // Tone 1: mid pitch
        this.playTone(audioCtx, 880, now);

        // Tone 2: slightly higher pitch
        this.playTone(audioCtx, 988, now + 0.14);
      } else {
        this.playChord(0.2, 200, volume, oscType);
      }
    }
  }
  async notifyUserError(actionResult: string = 'success') {
    let volume = this.getNotificationVolume();
    let oscType = 'triangle';

    if (volume) {
      if (actionResult === 'success') {
        const melody = [
          { duration: 0.1, frequency: 466 }, // Bb5 - tense starting note
          { duration: 0.2, frequency: 370 }, // F#4 - tritone resolution, descending
        ];

        let time = 0;
        melody.forEach((note) => {
          setTimeout(() => {
            this.playChord(note.duration, note.frequency, volume, oscType);
          }, time * 1000);
          time += note.duration;
        });
      } else {
        this.playChord(0.2, 200, volume, oscType);
      }
    }
  }
}
